export const base = 'gateway/main';
export const baseODATA = 'gateway/mainodata';

export const whatsAppPhone = `${base}/WhatsAppPhone`;
export const getChatToken = `${base}/WhatsAppPhone/GetChatToken`;
